import $ from 'jquery';
import LP from '../0-lp';
import UI from '../0-ui';

//=============== //
//INPUT QUESTION  //
//=============== //
LP.inputQuestion = {
  onLoad: function () {
    var tabname = LP.Dialog.getTabName();

    switch (tabname) {
      case 'advanced':
        LP.inputQuestion.advancedTab.initEvents();
        break;
      case 'codes':
        LP.questionTab.codes.initEvents();
        break;
    }
  },

  initNonAjaxTabs: function () {
    LP.inputQuestion.answerTab.initEvents();
    LP.inputQuestion.answerTab.checkFields();
  },

  answerTab: {
    initEvents: function (root) {
      if (!root) root = $('body');
      $('a[action="addInputField"]', root).click(function () {
        LP.dlgQuestion.addGroupHere($('#newGroup'), this.parentNode.parentNode, LP.inputQuestion.answerTab.initEvents);
      });
      LP.UI.initButtonMenu({
        selector: $('.lp-menubar-inputfields', root),
        name: 'scaleMenu',
      });
      $('a[action="toggleFixPos"]', root).click(LP.dlgQuestion.toggleFixPos);
      $('a[action="deleteInputField"]', root).click(function () {
        LP.dlgQuestion.deleteGroup(this, LP.inputQuestion.answerTab.checkFields);
      });

      $('a[action="editBeforInput"]', root).click(function () {
        LP.dlgQuestion.editInput($('input[name="question[textBefore][]"]', this.parentNode), this);
      });
      $('a[action="editAfterInput"]', root).click(function () {
        LP.dlgQuestion.editInput($('input[name="question[textAfter][]"]', this.parentNode), this);
      });

      $('.inputTypeChooser', root).change(function () {
        var fieldset = $(this).closest('fieldset');
        var sampleText = $('.inputExample', fieldset);
        sampleText.val($('#inputTextSample_' + $(this).val()).val());
      });

      // @Bug? Wenn diese aktiviert sind, dann wird immer ein zusätzlich leeres Feld erstellt, irgentwo enabled er vorher bereits dann die neue eingabefeld-vorlage
      //       Mit dem auskommentierten funktioniert das aber ganz gut ;)
      //$('.inputTypeChooser', root).removeAttr('disabled');
      //$('.lpjs-trigger', root).removeAttr('disabled');

      LP.inputQuestion.answerTab.checkFields();
    },

    checkFields: function () {
      var inputs = $('#inputFields');
      if ($('fieldset', inputs).length === 0) {
        LP.dlgQuestion.addGroup($('#newGroup'), inputs, LP.inputQuestion.answerTab.initEvents);
      }
      $('.inputnum', inputs).each(function (index, element) {
        $(element).html(index + 1 + '.');
      });
    },
  },

  advancedTab: {
    initEvents: function (root) {
      if (!root) root = $('body');
      $('a[action="editInputDefault"]', root).click(function () {
        var ref = $(this).attr('ref');
        LP.dlgQuestion.editInput($('input[name="' + ref + '"]', $(this).closest('tr')), this);
      });

      var sumMin = $('#input_sum_min');
      var sumMax = $('#input_sum_max');

      UI.setupSpinbox(sumMin, -2147483648, 2147483648, sumMin.val(), 1, false, 0, true, false, false);
      UI.setupSpinbox(sumMax, -2147483648, 2147483648, sumMax.val(), 1, false, 0, true, false, false);

      LP.dlgQuestion.initDefaultTextInputs();

      const uploadDiv = document.getElementById('react-uploadTypes');
      if (uploadDiv && !uploadDiv.getAttribute('data-init')) {
        window.reactPortals.addReactUploadInputField(uploadDiv);
        uploadDiv.setAttribute('data-init', true);
      }
    },
  },
};
